import React, { memo } from 'react';
import { Helmet } from 'react-helmet';

const HeaderMeta: React.FC = () => {
  // Ensure canonical URL always uses soundtools.com (not subdomains)
  const getCanonicalUrl = () => {
    const url = new URL(window.location.href);
    // Replace any subdomain with just soundtools.com
    url.hostname = 'soundtools.com';
    // Ensure https
    url.protocol = 'https:';
    return url.toString();
  };

  return (
    <Helmet>
      <title>SoundTools</title>
      <meta name='description' content='QUALITY TOOLS FOR THE AUDIO PRO' />
      <meta name='robots' content='index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' />
      <link rel='canonical' href={getCanonicalUrl()} />
    </Helmet>
  );
};

export default memo(HeaderMeta);
